// extracted by mini-css-extract-plugin
export default {"autoConvert":"AutoConvertCurrency_autoConvert__VgBiy","currencyIcon":"AutoConvertCurrency_currencyIcon__bZoMN","currencyLabel":"AutoConvertCurrency_currencyLabel__fAjGX"};